'use strict';

class RemoteData {

	static get remoteDataPoint() {
		if (window.location.hostname === 'localhost') {
			return 'http://specials.schirn.de/weneversleep/backend/req.php';
		} else {
			return 'backend/req.php';
		}
	}

	/**
	 * ajax call to backend
	 * @param params Request params object
	 * @param onDone callback function on success
	 * @param onFail callback function on error
	 * @returns {Deferred}
	 */
	static request(params, onDone, onFail) {
		return $.ajax({
			type: "GET",
			dataType: 'json',
			cache: false,
			url: RemoteData.remoteDataPoint,
			data: params,
		}).done(onDone).fail(onFail);
	}

	/**
	 *
	 * @param name
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static insertNewName(name, onDone, onFail = () => {}){
		let params = {action: 'insert_new_name', name: name};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 *
	 * @param name
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static insertNewName2(name, onDone, onFail = () => {}){
		let params = {action: 'insert_new_name2', name: name};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 * this is utter shit!
	 */
	static insertNewName3_01(name, onDone, onFail = () => {}){
		let params = {action: 'insert_new_name3_01', name: name};
		return RemoteData.request(params, onDone, onFail);
	}
	static insertNewName3_02(name, onDone, onFail = () => {}){
		let params = {action: 'insert_new_name3_02', name: name};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 *
	 * @param choice
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static castVote(choice, onDone, onFail = () => {}){
		let params = {action: 'cast_vote', choice: choice};
		return RemoteData.request(params, onDone, onFail);
	}
	/**
	 *
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static getVoteResults(onDone, onFail = () => {}){
		let params = {action: 'get_vote_results'};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 *
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static getNameslist(name, onDone, onFail = () => {}){
		let params = {action: 'get_nameslist', name: name};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 *
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static getNameslist2(name, onDone, onFail = () => {}){
		let params = {action: 'get_nameslist2', name: name};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 *
	 * @param assoc
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static insertNewAssoc(assoc, onDone, onFail = () => {}){
		let params = {action: 'insert_new_assoc', assoc: assoc};
		return RemoteData.request(params, onDone, onFail);
	}

	/**
	 *
	 * @param onDone
	 * @param onFail
	 * @returns {Deferred}
	 */
	static getAssoclist(assoc, onDone, onFail = () => {}){
		let params = {action: 'get_assoclist', assoc: assoc};
		return RemoteData.request(params, onDone, onFail);
	}

	static saveImage(base64img, onDone, onFail = () => {}) {
		let params = {action: 'save_image', base64img: base64img};
		return $.ajax({
			type: "POST",
			dataType: 'json',
			cache: false,
			url: RemoteData.remoteDataPoint,
			data: params,
		}).done(onDone).fail(onFail);
	}
}
